import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/estoque')({
  component: lazyRouteComponent(
    () => import('@/features/estoque/components/estoque-page'),
    'EstoquePage'
  ),
})
